import * as React from "react";
import {ChangeEvent, useState} from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from "@material-ui/core";
import {isErrorResponse, postList, SNSDataList} from "../../util/api";
import {useDispatch} from "react-redux";
import {
    AddSNSLists,
    DemoAddSNSLists,
    UpdateErrorSnackBar,
    UpdateSuccessSnackBar,
} from "../../actions";
import styles from "./css/addListModal.module.scss";

type AddListModalProps = {
    isOpen: boolean;
    setOpen: (open: boolean) => void;
    isDemo?: boolean;
};

export const AddListModal: React.FC<AddListModalProps> = (
    props: AddListModalProps
) => {
    const {isOpen, setOpen, isDemo} = props;

    const [listName, setListName] = useState("");
    const [errorText, setErrorText] = useState("");
    const [demoListId, setDemoListId] = useState(1000);
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();

    const handleClose = () => {
        setOpen(false);
    };

    const handleListNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setListName(event.target.value);
        setErrorText("");
    };

    const handleAddList = async () => {
        if (listName === "") {
            setErrorText("リスト名を入力してください");
            return;
        }
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        if (!isDemo) {
            const res = await postList(listName);
            if (isErrorResponse(res)) {
                dispatch(UpdateErrorSnackBar("リストの作成に失敗しました。"));
                setIsLoading(false);
                return;
            }
            const newList: SNSDataList = {
                id: res.id,
                name: listName,
                snsData: [],
                accounts: [],
            };
            dispatch(AddSNSLists(newList));
        } else {
            const newList: SNSDataList = {
                id: demoListId,
                name: listName,
                snsData: [],
                accounts: [],
            };
            setDemoListId(demoListId + 1);
            dispatch(DemoAddSNSLists(newList));
        }
        dispatch(UpdateSuccessSnackBar("リストを作成しました"));
        setOpen(false);
        setIsLoading(false);
        setListName("");
    };

    return (
        <div>
            <Dialog
                classes={{paperScrollPaper: styles.dialog}}
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle
                    id="form-dialog-title"
                    className={styles.text}
                    style={{textAlign: "center"}}
                >
                    リスト作成
                </DialogTitle>
                <DialogContent>
                    <TextField
                        id="listName"
                        label="リスト名"
                        variant="outlined"
                        value={listName}
                        onChange={handleListNameChange}
                        error={errorText !== ""}
                        helperText={errorText}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions className={styles.buttonWrapper}>
                    <Button onClick={handleClose} color="primary">
                        キャンセル
                    </Button>
                    <Button
                        onClick={handleAddList}
                        className={styles.addButton}
                        color="primary"
                    >
                        {isLoading ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : (
                            "作成"
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
